import { BaseCartClient, CartState, RawCartResponse } from "@core/types";
import { convertCartToSupaCart, convertSupaCartToCart } from "./converters";
class CartClient extends BaseCartClient {
  async updateCart(cart: CartState, shippingZone: string): Promise<CartState | null> {
    const supaCart = convertCartToSupaCart(cart);

    const response = await this.instance.post<RawCartResponse | null>("/wp-json/parhato-api/v1/cart", {
      ...supaCart,
      shippingZone,
    });

    const data = response?.data;

    return data ? convertSupaCartToCart(data) : null;
  }
}

export default CartClient;
